import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterUnidades() {
        return axiosJwt
            .get(`${api}/credenciados/uabs/dotacoes/unidades`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterProjetos(codUnidade) {
        return axiosJwt
            .get(
                `${api}/credenciados/uabs/dotacoes/unidades/${codUnidade}/projetos`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAcoes(codUnidade, codProjeto) {
        return axiosJwt
            .get(
                `${api}/credenciados/uabs/dotacoes/unidades/${codUnidade}/projetos/${codProjeto}/acoes`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
